import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { COLORS } from '@/globals/global.styles'
import SustainabilityImage from 'Assets/images/sustainability.svg'
import { selectIsWhiteLabel } from 'Src/redux/reservation/reservation.selectors'
import { TranslationContext } from 'Src/context'

const PageFooterStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: -16px;
	padding: 38px 0;
	background-color: ${COLORS.background.secondary};
	gap: 24px;
`

const Link = styled.a`
	font-weight: 500;
	font-size: 14px;
	line-height: 1.5em;
	color: ${COLORS.text.link};
	text-decoration: none;
`

const CookieSettings = styled.a`
	font-weight: 400;
	font-size: 14px;
	line-height: 1.5em;
	color: ${COLORS.text.secondary};
	text-align: center;
`

const PageFooter : FC = () => {
	const translation = useContext(TranslationContext)
	const isWhiteLabel = useSelector(selectIsWhiteLabel)

	if (isWhiteLabel)	{
		return null
	}

	const showCookieSettings = () => {
		// eslint-disable-next-line no-underscore-dangle
		window.__ucCmp?.showSecondLayer()
	}

	return (
		<PageFooterStyled>
			<Link
				href="https://bobw.co/sustainability?lng=en-GB"
				target="_blank"
			>
				<img
					src={SustainabilityImage}
					alt=""
				/>
			</Link>
			<CookieSettings
				href="#"
				rel="noopener noreferrer"
				onClick={showCookieSettings}
			>
				{translation.t('Cookie Settings')}
			</CookieSettings>
		</PageFooterStyled>
	)
}

export default PageFooter
